import { gql } from '@apollo/client'

import { LOCATION_FRAGMENT } from '..'

import { SHOP_APPLIED_DISCOUNT_CODE_FRAGMENT } from './appliedDiscountCode'
import { SHOP_APPLIED_GIFT_CARD_FRAGMENT } from './appliedGiftCard'
import { SHOP_APPLIED_TIP_VARIANT_FRAGMENT } from './appliedTipVariant'
import { SHOP_CART_FULFILLMENT_FRAGMENT } from './cartFulfillment'
import { SHOP_CART_ITEM_FRAGMENT } from './cartItems'
import { SHOP_CUSTOM_FEE_FRAGMENT } from './customFees'

export const SHOP_CART_FRAGMENT = gql`
  fragment ShopCart on ShopCart {
    absorbShopAppFee
    appliedDiscountCodes {
      ...ShopAppliedDiscountCode
    }
    appliedGiftCards {
      ...ShopAppliedGiftCard
    }
    appliedTipVariant {
      ...ShopAppliedTipVariant
    }
    availablePickupLocations {
      ...Location
    }
    cartItems {
      ...ShopCartItem
    }
    customFees {
      ...ShopCustomFee
    }
    driverTipMoney
    driverTipMoneyFormatted
    freeShipping
    fulfillment {
      ...ShopCartFulfillment
    }
    hasAppliedDiscountCodes
    hasAppliedGiftCards
    hasDeliverableItems
    hasFulfillableItems
    hasPickupableItems
    hasShippingableItems
    hstForAppFeeMoney
    hstForAppFeeMoneyFormatted
    hstForDeliveryCostMoney
    hstForDeliveryCostMoneyFormatted
    id
    noItems
    note
    shopId
    shopAppFeeMoney
    shopAppFeeMoneyFormatted
    itemsTotalTipMoney
    itemsTotalTipMoneyFormatted
    totalDeliveryCostMoney
    totalDeliveryCostMoneyFormatted
    totalDiscountMoney
    totalDiscountMoneyFormatted
    totalShippingCostMoney
    totalShippingCostMoneyFormatted
    totalGiftCardMoney
    totalGiftCardMoneyFormatted
    totalItems
    totalMoney
    totalMoneyFormatted
    totalPrice
    totalPriceFormatted
    totalTaxAndFeesMoney
    totalTaxAndFeesMoneyFormatted
    totalTaxMoney
    totalTaxMoneyFormatted
    utensils
  }
  ${SHOP_APPLIED_DISCOUNT_CODE_FRAGMENT}
  ${SHOP_APPLIED_TIP_VARIANT_FRAGMENT}
  ${SHOP_APPLIED_GIFT_CARD_FRAGMENT}
  ${LOCATION_FRAGMENT}
  ${SHOP_CART_ITEM_FRAGMENT}
  ${SHOP_CUSTOM_FEE_FRAGMENT}
  ${SHOP_CART_FULFILLMENT_FRAGMENT}
`
